import { render, staticRenderFns } from "./industryChain.vue?vue&type=template&id=5bf4be15&scoped=true&"
import script from "./industryChain.vue?vue&type=script&lang=js&"
export * from "./industryChain.vue?vue&type=script&lang=js&"
import style0 from "./industryChain.vue?vue&type=style&index=0&id=5bf4be15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf4be15",
  null
  
)

export default component.exports